export default "__VITE_ASSET__CDYibqRF__"